module.exports = __webpack_public_path__ + "media/components/src/assets/images/staffs/staff_1-13f5372deaac07db6987260953b37f86.jpg";